// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__Nn0qk","colMin":"styles_colMin__2kV5a","colCheckbox":"styles_colCheckbox__MlbFC"};